import { useState } from 'react';
import { Menu } from 'antd';
import { RibbonButton } from 'common/components';
import ProfessionallyCaptureProductModal from './ProfessionallyCaptureProductModal';

import messages from 'i18n/messages/home';
import IX_One_Logo2285 from 'assets/IX_One_Logo2285.png';

const ProfessionallyCaptureProductButton = () => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Menu.Item
        key='professionally-capture-product'
        style={{
          backgroundColor: 'inherit',
        }}
      >
        <RibbonButton
          className='button-item-dropdown'
          icon={
            <img
              src={IX_One_Logo2285}
              alt='IX-ONE Capture'
              style={{ width: '20px', background: '#ffffff' }}
            />
          }
          label={messages.professtionallyCaptureProduct}
          onClick={() => setVisible(true)}
          size='small'
        />
      </Menu.Item>
      {visible && (
        <ProfessionallyCaptureProductModal
          visible={visible}
          setVisible={setVisible}
        />
      )}
    </>
  );
};

export default ProfessionallyCaptureProductButton;
